import React, { useEffect, useState } from 'react';
import { ContentHeader, Table } from '@app/shared';

import { useTransactionReasons } from '@app/sdk';
import { ComponentErrorBoundary } from '@app/utilities';
import { ColDef } from 'ag-grid-community';
import { MasterDetailLayout } from '../../components/MasterDetailLayout';
import { TransactionReasonForm } from './TransactionReasonForm';
import { Segment } from 'semantic-ui-react';

export function TransactionReasons() {
  const [selectedTransactionReason, setSelectedTransactionReason] = useState(undefined as any);
  const { data: transactionReasons } = useTransactionReasons();
  const [transactionReason, setTransactionReason] = useState();
  const columnDefs: ColDef[] = [
    { field: 'id', headerName: 'Id' },
    { field: 'reason', headerName: 'Reason' },
    { field: 'transactionType', headerName: 'Type' },
    { field: 'transactionDirection', headerName: 'Direction' },
    { field: 'description', headerName: 'Description' },
    { field: 'transactionSource', headerName: 'Source' },
    { field: 'isDefault', headerName: 'Is Default' },
  ];

  useEffect(() => {
    if (!selectedTransactionReason) {
      setTransactionReason(null);
      return;
    }
    setTransactionReason({
      ...selectedTransactionReason,
      transactionDirection: selectedTransactionReason.transactionDirection?.join(','),
    });
  }, [selectedTransactionReason]);

  const master = (
    <>
      <ContentHeader>
        Transaction Reasons
        <button className={'ui button'} onClick={() => setTransactionReason(undefined)} disabled>
          Add Transaction Reason
        </button>
      </ContentHeader>
      <div style={{ height: 'calc(100% - 100px)' }}>
        <Table items={transactionReasons} onSelectItem={setSelectedTransactionReason} columnDefs={columnDefs} />
      </div>
    </>
  );

  const detail = (
    <Segment>
      <ContentHeader>{transactionReason ? 'Update Transaction Reason' : 'Add Transaction Reason'}</ContentHeader>
      <TransactionReasonForm key={JSON.stringify(transactionReason)} transactionReason={transactionReason} />
    </Segment>
  );

  return (
    <ComponentErrorBoundary>
      <MasterDetailLayout master={master} detail={detail} />
    </ComponentErrorBoundary>
  );
}
